// rating-control.js
;(({ $, $$ , log}) => {
    const selectedClass = 'rating-control__star--selected'
    const hoveredClass = 'rating-control__star--hovered'

    $$('.rating-control').forEach(rating => {
        const stars = Array.from(rating.querySelectorAll('.rating-control__star'))
        const input = rating.querySelector('.rating-control__input')
        if (stars.length < 5 || !input) return

        updateSelectedStars(stars, input)

        stars.forEach(star => {
            star.addEventListener('click', e => {
                input.value = getStarIndex(stars, star) + 1
                input.dispatchEvent(new Event('input'))
            })

            star.addEventListener('mouseenter', () => {
                updateHoveredStars(stars, getStarIndex(stars, star))
            })
        })

        rating.addEventListener('mouseenter', () => clearSelectedStars(stars))

        rating.addEventListener('mouseleave', () => {
            clearHoveredStars(stars)
            updateSelectedStars(stars, input)
        })
    })

    function getStarIndex(stars, star) {
        for (let i = 0; i < stars.length; ++i) {
            if (star === stars[i]) {
                return i
            }
        }

        return null
    }

    function updateSelectedStars(stars, input) {
        const lastActiveIndex = parseInt(input.value) - 1
        stars.forEach((star, i) => {
            if (i <= lastActiveIndex) {
                star.classList.add(selectedClass)
            } else {
                star.classList.remove(selectedClass)
            }
        })
    }

    function clearSelectedStars(stars) {
        stars.forEach(star => star.classList.remove(selectedClass))
    }

    function updateHoveredStars(stars, index) {
        stars.forEach((star, i) => {
            if (i <= index) {
                star.classList.add(hoveredClass)
            } else {
                star.classList.remove(hoveredClass)
            }
        })
    }

    function clearHoveredStars(stars) {
        stars.forEach(star => star.classList.remove(hoveredClass))
    }
})(CNS);